import styled from 'styled-components';
import { Layout } from '@design-system';

const CommonMessageWrapper = styled(Layout.FlexRow).attrs({
  w: '100%',
  gap: 0,
  alignItems: 'flex-end',
})``;

export const LeftMessageWrapper = styled(CommonMessageWrapper).attrs({
  justifyContent: 'flex-start',
  pl: 4,
})``;

export const RightMessageWrapper = styled(CommonMessageWrapper).attrs({
  justifyContent: 'flex-end',
  pr: 10,
})``;

export const SenderAvatarSlot = styled.div`
  width: 32px;
  flex-shrink: 0;
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const CommonBubble = styled(Layout.FlexCol).attrs({
  pv: 8,
  ph: 13,
})`
  max-width: min(75vw, 340px);
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const LeftBubble = styled(CommonBubble).attrs({
  bgColor: 'LIGHT',
})`
  border-radius: 13px 13px 13px 0px;
`;

export const RightBubble = styled(CommonBubble).attrs({
  bgColor: 'SECONDARY',
})`
  border-radius: 13px 13px 0px 13px;
`;

export const ReactionBadge = styled(Layout.FlexRow).attrs({
  gap: 2,
  ph: 6,
  pv: 2,
  rounded: 10,
  alignItems: 'center',
})`
  background: #f0f0f0;
  border: 1px solid #e0e0e0;
`;

export const ParentPreview = styled(Layout.FlexCol).attrs({
  ph: 10,
  pv: 4,
  rounded: 8,
})`
  opacity: 0.7;
  border-left: 2px solid #87dfff;
  background: white;
  max-width: min(75vw, 340px);
`;

export const SystemMessageRow = styled(Layout.FlexRow).attrs({
  w: '100%',
  justifyContent: 'center',
  ph: 17,
  pv: 4,
})``;

export const TypingBubble = styled(Layout.FlexRow).attrs({
  gap: 3,
  alignItems: 'center',
  pv: 9,
  ph: 12,
})`
  width: 48px;
  border-radius: 13px 13px 13px 0px;
  background: ${({ theme }) => theme.LIGHT};
`;

export const TypingDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${({ theme }) => theme.MEDIUM_GRAY};
  animation: wit-bot-typing-dot 1s ease-in-out infinite;

  &:nth-child(2) {
    animation-delay: 0.14s;
  }

  &:nth-child(3) {
    animation-delay: 0.28s;
  }

  @keyframes wit-bot-typing-dot {
    0%,
    80%,
    100% {
      opacity: 0.35;
      transform: translateY(0);
    }
    40% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
`;
